import dayjs from 'dayjs';
/**
 * Set localStorage
 */
 export const setStore = (name, content) => {
    if (!name) return
    if (typeof content !== 'string') {
      content = JSON.stringify(content)
    }
    return window.localStorage.setItem(name, content)
  }
  
  /**
    * Get localStorage
  */
  export const getStore = (name) => {
    if (!name) return undefined;
    return JSON.parse(window.localStorage.getItem(name))
  }
  
  /**
   * Clear localStorage
  */
  export const removeItem = (name) => {
    if (!name) return
    return window.localStorage.removeItem(name)
  }
  
  /**
   * Validate Email address
   */
  export const isValidEmail = (value) => {
    return !(value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,64}$/i.test(value))
  }
  
  /**
   * Format Phone Number
   */
  export const formatPhoneNumber = (value) => {
    if (!value) return
    const currentValue = value.replace(/[^\d]/g, '');
    const mobileNoLength = currentValue.length;
    if (mobileNoLength >=7) {
      if (mobileNoLength < 4) return currentValue;
      if (mobileNoLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
      return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
    } else{
      return currentValue;
    }
  }
  
  
  export const checkStatusError = (res) => {
      if (!res.ok) {
          throw new Error(res.statusText);
      }
      return res;
  }

  export const getTicketId = (id) => {
    if (id) {
      return id.slice(-6)
    }
    return ''
  }

  export const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }

export const downloadBook = (book) => {
  const user = getStore('user');
  const shouldDownload = user?.user?.downloadBooking
  
  if (shouldDownload) {
    const fileName = `${dayjs(book.from).format('DD-MM-YYYY-HH-MM')}_${book.tenant.name.toLowerCase()}_${getTicketId(book._id)}.txt`;
let content = `
${book.tenant.name} (${book.status})
${dayjs(book.from).format('DD-MM-YYYY HH:MM')} => ${dayjs(book.to).format('DD-MM-YYYY HH:MM')}
Advance : ₹${book.advance}, Balance: ₹${book.amount-book.advance}
${book.billableDates.length} billable days

Products
========
${book.products.map((prd, index) => {
const items = book.items.filter(item => item.product === prd.id)
return ` ${index+1}. ${prd.name} x ${prd.count} [${items.map(item => item.sku).join(",")}] `
}).join("\n")}
`;
if (book.notes['bookingNotes']) {
content += `
Notes
======
${book.notes['bookingNotes']}
`
}

    const blob = new Blob([content], { type: "text/plain;charset=utf-8;" });

    // Create a temporary URL
    const url = URL.createObjectURL(blob);

    // Create a temporary <a> element
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);

    // Append, click, and remove
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Cleanup
    URL.revokeObjectURL(url);
  }
}